export function mergeAddressForDisplay(address) {
  if (!address) return "";
  const a = String(address.line1 ?? "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .trimEnd();
  const b = String(address.line2 ?? "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n");
  if (!a.trim() && !b.trim()) return "";
  if (!b.trim()) return a;
  if (!a.trim()) return b;
  return `${a}\n${b}`;
}

export function normalizeAddressForApi(address) {
  if (!address || typeof address !== "object") return address;
  const text = String(address.line1 ?? "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n");
  const rows = text.split("\n");
  const line1 = (rows[0] ?? "").trimEnd();
  const extraLinesFromAddressField = rows.slice(1).join("\n").trimEnd();
  const line2FromSavedAddress = String(address.line2 ?? "").trim();
  const line2 = [extraLinesFromAddressField, line2FromSavedAddress]
    .filter(Boolean)
    .join("\n");
  return { ...address, line1, line2 };
}
